//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    entity: {
      required: true,
    },
  },
  computed: {
    entityType() {
      if (this.entity === "LLC") return "LLC";
      else if (this.entity === "Nonprofit") return "Nonprofit";
      else return "corporation";
    },
  },
};
